import React, {useState} from 'react';

import css from './PriceComponent.module.css';
import {useTranslation} from "react-i18next";
import {PriceListComponent} from "../PriceListComponent/PriceListComponent";


const PriceComponent = () => {
    const [isShow, setIsShow] = useState(false);
    const {t} = useTranslation();


    return (
        <section className={css.wrap}>

            <section className={css.btnBlock}>
                <button type="button"
                        className={`${css.btn} ${css.simple} ${!isShow ? css.buttonActive : ''}`}
                        onClick={() => setIsShow(false)}>
                    {t('Simple')}
                </button>
                <button type="button"
                        className={`${css.btn} ${css.table} ${isShow ? css.buttonActive : ''}`}
                        onClick={() => setIsShow(true)}>
                    {t('Table')}
                </button>
            </section>

            <section className={css.listBlock}>
                <PriceListComponent isShow={isShow}/>
            </section>
        </section>
    );
};

export {PriceComponent};